// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import mainSlider from './js/widgets/mainSlider.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainSlider();
    eventsWidget();
    cardsWidget();
    seoWidget();
    sponsors();
  });
}

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
});
